import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      & + & {\n        margin-top: 8px;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      a {\n        color: ", ";\n\n        :focus,\n        :hover {\n          color: ", ";\n        }\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ", ";\n  width: 100%;\n\n  /* Create a function resolver that returns css if needed */\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { Paragraph } from '@scp/ui-shared/components/typography';
import { color, property } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var E2E_SUFFIX = '-information-banner';
var PADDING_BY_SPACING = {
  small: '0px 10px',
  default: '10px'
};
var TEXT_COLOR_BY_TYPE = {
  alert: color.palette.white,
  blue: color.textPrimary,
  success: color.textPrimary,
  information: color.palette.white,
  dark: color.palette.white,
  grey: color.textPrimary,
  darkGrey: color.palette.white,
  purple: color.textPrimary,
  yellow: color.textPrimary
};
var BANNER_COLOR_BY_TYPE = {
  alert: color.alert,
  blue: color.palette.blue100,
  success: color.palette.green900,
  information: color.info,
  dark: color.backgroundDark,
  grey: color.palette.grey800,
  darkGrey: color.palette.grey400,
  purple: color.palette.purple900,
  yellow: color.palette.yellow900
};
var InformationBannerWrapper = styled.div(_templateObject(), function (_ref) {
  var type = _ref.type;
  return type && BANNER_COLOR_BY_TYPE[type];
}, function (props) {
  return props.rounded ? property.borderRadius : 0;
}, function (_ref2) {
  var spacing = _ref2.spacing;
  return spacing && PADDING_BY_SPACING[spacing];
}, function (props) {
  return props.type === 'dark' && css(_templateObject2(), color.linkSecondary, color.actionHover);
}, function (props) {
  return props.spaceBetween && css(_templateObject3());
});
export var InformationMessage = styled(Paragraph)(_templateObject4(), function (_ref3) {
  var type = _ref3.type;
  return type && TEXT_COLOR_BY_TYPE[type];
});
/**
 * Simple information banner to display text in.
 *
 * @example ./__docs__/InformationBanner.md
 */

export function InformationBanner(_ref4) {
  var children = _ref4.children,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'alert' : _ref4$type,
      _ref4$spacing = _ref4.spacing,
      spacing = _ref4$spacing === void 0 ? 'default' : _ref4$spacing,
      _ref4$rounded = _ref4.rounded,
      rounded = _ref4$rounded === void 0 ? false : _ref4$rounded,
      _ref4$spaceBetween = _ref4.spaceBetween,
      spaceBetween = _ref4$spaceBetween === void 0 ? false : _ref4$spaceBetween,
      dataE2e = _ref4.dataE2e;

  if (!children) {
    return null;
  }

  var isChildrenString = typeof children === 'string';
  return React.createElement(InformationBannerWrapper, {
    type: type,
    spacing: spacing,
    rounded: rounded,
    spaceBetween: spaceBetween,
    "data-e2e": getE2eLabel(children, E2E_SUFFIX, dataE2e)
  }, isChildrenString ? React.createElement(InformationMessage, {
    type: type,
    noMargin: true
  }, children) : children);
}